import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { ToastService } from '../../../_core/services/toast.service';
import { UserService } from '../../../_core/services/user.service';
import { User } from '../../models/user.model';
interface ImageUploadedData {
  image: any;
  imageChanged: boolean;
}
@Component({
  standalone: false,
  selector: 'app-add-player',
  templateUrl: './add-player.component.html',
  styleUrls: ['./add-player.component.scss'],
})
export class AddPlayerComponent implements OnInit {
  @Input() user: User;
  @Input() editModal: boolean;

  form: UntypedFormGroup;
  submittingForm = false;
  isEdit = false;
  banner_image_web :ImageUploadedData
  banner_image_mobile:ImageUploadedData
  action_shot_image:ImageUploadedData
  private _userImage: ImageUploadedData;

  constructor(
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private modalCtrl: ModalController,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    !this.user ? (this.user = new User()) : (this.isEdit = true);
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      first_name: [
        this.user.first_name,
        [Validators.required, Validators.minLength(1)],
      ],
      last_name: [
        this.user.last_name,
        [Validators.required, Validators.minLength(1)],
      ],
      sex: [this.user?.biographicalInformation?.sex],
      height: [this.user?.biographicalInformation?.height],
      age: [this.user?.biographicalInformation?.age],
      hometown: [
        this.user.hometown,
      ],
      address: [
        this.user.address,
      ],
      about: [
        this.user.about?.trim(),
        [Validators.maxLength(2000)],
      ],
        facebook: [
          this.user?.social_media_urls?.facebook || '',
        ],
        instagram: [
          this.user?.social_media_urls?.instagram || '',
        ],
        x: [
          this.user?.social_media_urls?.x || '',
        ],
        tiktok: [
          this.user?.social_media_urls?.tiktok || '',
        ],
        youtube: [
          this.user?.social_media_urls?.youtube || '',
        ],
        linkedin: [
          this.user?.social_media_urls?.linkedin || '',
        ],
    });
  }  

  setBannerImageWeb(data: ImageUploadedData){
    this.banner_image_web = data;
  }
  setBannerImageMobile(data: ImageUploadedData){
    this.banner_image_mobile = data
  }
  setActionShotImage(data: ImageUploadedData){
    this.action_shot_image = data;
  }

  async submit() {
    if (this.form.valid) {
      this.submittingForm = true;

      const formData = new FormData();
      Object.keys(this.form.value).forEach((key) => {
        if(["facebook","instagram","x","youtube","tiktok","linkedin"].includes(key)) return;
        if(this.form.value[key]===null||this.form.value[key]===undefined) return;
        formData.append(key, this.form.value[key]);
      });
      if (this.banner_image_web?.image) {
        const blob = await fetch(this.banner_image_web?.image).then((res) =>
          res.blob()
        );
        formData.append('banner_image_web', blob);
      } else {
        formData.append('banner_image_web', ''); 
      }

      if (this.banner_image_mobile?.image) {
        const blob = await fetch(this.banner_image_mobile?.image).then((res) =>
          res.blob()
        );
        formData.append('banner_image_mobile', blob);
      } else {
        formData.append('banner_image_mobile', ''); 
      }

      if (this.action_shot_image?.image) {
        const blob = await fetch(this.action_shot_image?.image).then((res) =>
          res.blob()
        );
        formData.append('action_shot_image', blob);
      } else {
        formData.append('action_shot_image', ''); 
      }

      const socailmedia_Url= {
          facebook:this.form.value.facebook,
          instagram:this.form.value.instagram,
          x:this.form.value.x,
          youtube:this.form.value.youtube,
          linkedin:this.form.value.linkedin,
          tiktok:this.form.value.tiktok,

      }

      formData.append("social_media_urls",JSON.stringify(socailmedia_Url))

      // Handle profile_image if it's available
      if (this._userImage?.image) {
        const blob = await fetch(this._userImage?.image).then((res) =>
          res.blob()
        );
        formData.append('profile_image', blob);
      } else {
        formData.append('profile_image', ''); // Add empty string if no image
      }
      formData.append('isImageChange', (this._userImage?.imageChanged || false).toString());
      formData.append('isBannerImageWebChanged', (this.banner_image_web?.imageChanged || false).toString());
      formData.append('isBannerImageMobileChanged', (this.banner_image_mobile?.imageChanged || false).toString());
      formData.append('isActionShotImageChanged', (this.action_shot_image?.imageChanged || false).toString());

      if (!this.isEdit) {
        this.userService
          .create(formData)
          .pipe(finalize(() => (this.submittingForm = false)))
          .subscribe(
            (res) => {
              this.toastService.presentToast(res.message);
              this.modalCtrl.dismiss(res.data);
            },
            (err) => {
              //console.log(err)
            }
          );
      } else {
        this.userService
          .update(this.user._id, formData)
          .pipe(finalize(() => (this.submittingForm = false)))
          .subscribe(
            (res) => {
              this.modalCtrl.dismiss({
                ...this.user,
                ...res.data, 
              });
            },
            (err) => {
              //console.log(err)
            }
          );
      }
    } else {
      this.handleErrors();
    }
  }

  handleErrors() {
    let errorMessage = '';
    if (this.form.get('first_name')?.invalid) {
      errorMessage = 'First name is required.';
    } else if (this.form.get('last_name')?.invalid) {
      errorMessage = 'Last name is required.';
    }
    else if (this.form.get('about')?.hasError('maxlength')) {
      errorMessage = 'Bio exceeds the 2000 character limit.';
    }
    this.toastService.presentDangerToast(errorMessage);
  }

  close() {
    this.modalCtrl.dismiss();
  }

  clear() {
    this.form.reset();
  }

  imageSelected(data: ImageUploadedData) {
    this._userImage = data;
  }
}
